import { defineComponent as _defineComponent } from 'vue'

import commonProps from "../props/commonProps";

export interface TextInputFormatter {
  format: (value: string) => string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCustom',
  props: {
  ...commonProps,
  textInputFormatters: {
    type: Array as () => TextInputFormatter[],
    default: () => [],
  },
  patternMessage: { type: String, default: "Valor inválido." },
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit }) {
  __expose();

const props = __props;





const applyFormatters = (value: string) => {
  return props.textInputFormatters.reduce((formattedValue, formatter) => {
    return formatter.format(formattedValue);
  }, value);
};

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  target.setCustomValidity("");
  const formattedValue = applyFormatters(target.value);
  target.value = formattedValue;
  emit("update:modelValue", formattedValue);
};

const handleInvalid = (event: Event) => {
  const target = event.target as HTMLInputElement;

  if (target.validity.patternMismatch) {
    target.setCustomValidity(props.patternMessage);
  }
};

const __returned__ = { props, emit, applyFormatters, handleInput, handleInvalid }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})